export default "__VITE_ASSET__DXKS$EZ3__"